import InitiativeLayout from './initiativeLayout.js';

export default InitiativeLayout;
